'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valueToString;
/**
 * Converts number values to a string with a unit.
 */
function valueToString(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

  return typeof value === 'number' ? '' + value + unit : value;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy92YWx1ZS10by1zdHJpbmcuanMiXSwibmFtZXMiOlsidmFsdWVUb1N0cmluZyIsInZhbHVlIiwidW5pdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBR3dCQSxhO0FBSHhCOzs7QUFHZSxTQUFTQSxhQUFULENBQXVCQyxLQUF2QixFQUEyQztBQUFBLE1BQWJDLElBQWEsdUVBQU4sSUFBTTs7QUFDeEQsU0FBTyxPQUFPRCxLQUFQLEtBQWlCLFFBQWpCLFFBQStCQSxLQUEvQixHQUF1Q0MsSUFBdkMsR0FBZ0RELEtBQXZEO0FBQ0QiLCJmaWxlIjoidmFsdWUtdG8tc3RyaW5nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb252ZXJ0cyBudW1iZXIgdmFsdWVzIHRvIGEgc3RyaW5nIHdpdGggYSB1bml0LlxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB2YWx1ZVRvU3RyaW5nKHZhbHVlLCB1bml0ID0gJ3B4Jykge1xuICByZXR1cm4gdHlwZW9mIHZhbHVlID09PSAnbnVtYmVyJyA/IGAke3ZhbHVlfSR7dW5pdH1gIDogdmFsdWVcbn1cbiJdfQ==